<template>
  <div class="auth-main auth-main__prp">
    <main
      id="main"
      class="main--login"
      data-page-id="login"
    >
      <section class="section-login">
        <!--        <Header :is-whitelabel="isWhitelabel" /> -->
        <div class="login-form-wrapper">
          <div class="loginv2-container p-b-20">
            <div class="row p-10">
              <div
                class="login_logo login_logo__prp"
                :class="{ 'login_logo--ringba': !isWhitelabel }"
              />
              <br>
            </div>
            <slot />
          </div>
        </div>
      </section>
      <Footer v-if="!isWhitelabel" />
      <WhitelabelFooter v-if="isWhitelabel" />
    </main>
  </div>
</template>

<script>

import messages from '../locales';
import Footer from '@/modules/auth/components/Footer';
import WhitelabelFooter from '@/modules/auth/components/WhitelabelFooter';

export default {
  components: { Footer, WhitelabelFooter },
  props: {
    isWhitelabel: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },

  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>
.auth-main.auth-main__prp {
--component-login__body-bg: var(--component-publisher-registration__center-bg);
--component-login__font-color: var(--component-publisher-registration__font-color);
--component-login__welcome-message-font-color: var(--component-publisher-registration__welcome-message-font-color);
}

.login_logo.login_logo__prp {
  height: 85px;
  margin: 0 auto;
}
</style>